var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.readyToPlay)?_c('video-player',{attrs:{"src":_vm.playbackUrl,"options":_vm.videoOptions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }